export default __webpack_public_path__ + "static/media/F_wdt_c_cap_2.78f13acb.mp3";